import { type JSX } from 'react';
import { useRouteError } from 'react-router-dom';
import { Button, Container, Text, Title } from '@mantine/core';
import classes from './ErrorBoundary.module.css';

function RouteErrorFallback(): JSX.Element {
  const error = useRouteError();
  const is404 = error instanceof Response ? error.status === 404 : false;

  return (
    <Container className={classes.root}>
      <Title className={classes.title}>{is404 ? 'Page not found' : 'Something went wrong'}</Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        {is404
          ? "The page you're looking for doesn't exist."
          : 'An unexpected error occurred. Please try refreshing the page.'}
      </Text>
      <Button variant="subtle" size="md" component="a" href="/">
        Go Home
      </Button>
    </Container>
  );
}

export default RouteErrorFallback;
